<app-partner-terms></app-partner-terms>
<app-bottom-menu></app-bottom-menu>